import { render, staticRenderFns } from "./MUS002-Ingreso.vue?vue&type=template&id=71a2f747&"
import script from "./MUS002-Ingreso.vue?vue&type=script&lang=js&"
export * from "./MUS002-Ingreso.vue?vue&type=script&lang=js&"
import style0 from "./MUS002-Ingreso.vue?vue&type=style&index=0&id=71a2f747&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports